import 'twin.macro';
import React from 'react';
import { closeYearsAvailable } from '@teetsh/app/src/containers/MesAnneesScolaires/Schoolyear/yearsAvailable';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { CheckIcon as Check } from '@heroicons/react/24/outline';
import { ZoneId } from 'types/zone';
import tw from 'twin.macro';
import { coloredButtonStyle } from 'components/Form/ButtonsRadio';

interface Props {
  value?: number;
  existingYears: number[];
  zone: ZoneId;
  onChange: (v: number) => void;
}

function formatYearLabel(year: number, zone: ZoneId) {
  if (zone === 'nouvelle-caledonie') {
    return year;
  }
  return `${year - 1} - ${year}`;
}

export default function YearsSelector(props: Props) {
  const { value, onChange, existingYears, zone } = props;
  return (
    <div tw="grid sm:grid-cols-3 gap-3">
      {closeYearsAvailable.map(option => {
        const yearExists = existingYears.includes(option.value);
        return (
          <Button
            key={option.value}
            large
            active={option.value === value}
            disabled={yearExists}
            css={[
              coloredButtonStyle({
                active: option.value === value,
              }),
              option.value === value &&
                tw`bg-brand-moderate text-brand-intense`,
            ]}
            icon={yearExists ? Check : undefined}
            onClick={() => onChange(option.value)}
          >
            {formatYearLabel(option.value, zone)}
          </Button>
        );
      })}
    </div>
  );
}
